import React from "react";

const Sunrise = ({ className, height, width }) => {
  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 100 60"
      className={className}
    >
      <path
        d="M99,55H81c-0.3-5.3-3.4-30-31-30S19.4,49.7,19,55H1c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h98c0.6,0,1-0.4,1-1
		C100,55.4,99.6,55,99,55z M50,27c12,0,20.5,4.8,25.3,14.4C78.2,47,78.8,52.8,79,55H21C21.3,49.8,24,27,50,27z"
      />
      <path
        d="M1.7,36.2l12.9,5.7C14.7,42,14.9,42,15,42c0.4,0,0.7-0.2,0.9-0.6c0.2-0.5,0-1.1-0.5-1.3L2.5,34.3c-0.5-0.2-1.1,0-1.3,0.5
		C0.9,35.4,1.2,35.9,1.7,36.2z"
      />
      <path
        d="M85,42c0.1,0,0.3,0,0.4-0.1l12.9-5.7c0.5-0.2,0.7-0.8,0.5-1.3c-0.2-0.5-0.8-0.7-1.3-0.5l-12.9,5.7
		c-0.5,0.2-0.7,0.8-0.5,1.3C84.3,41.8,84.6,42,85,42z"
      />
      <path
        d="M25.7,24.5c0.2,0.2,0.5,0.3,0.7,0.3c0.2,0,0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0.1-1.4l-9.5-10.5c-0.4-0.4-1-0.4-1.4-0.1
		c-0.4,0.4-0.4,1-0.1,1.4L25.7,24.5z"
      />
      <path
        d="M73.2,24.8c0.3,0,0.5-0.1,0.7-0.3L83.4,14c0.4-0.4,0.3-1-0.1-1.4c-0.4-0.4-1-0.3-1.4,0.1l-9.5,10.5c-0.4,0.4-0.3,1,0.1,1.4
		C72.7,24.7,72.9,24.8,73.2,24.8z"
      />
      <path
        d="M45.8,7.9l3.2-4V16c0,0.6,0.4,1,1,1s1-0.4,1-1V3.8l3.2,4c0.2,0.2,0.5,0.4,0.8,0.4c0.2,0,0.4-0.1,0.6-0.2
		c0.4-0.3,0.5-1,0.2-1.4l-5-6.3c-0.4-0.5-1.2-0.5-1.6,0l-5,6.3C43.9,7,43.9,7.7,44.4,8C44.8,8.4,45.4,8.3,45.8,7.9z"
      />
    </svg>
  );
};

export default Sunrise;



// WEBPACK FOOTER //
// ./resources/assets/js/app/Icons/Sunrise.icon.js